import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

const BasicRadioGroup = ({ choices, defaultValue, onChange }) => {
  return (
    <RadioGroup
      aria-labelledby="active-radio-buttons-group-label"
      defaultValue={defaultValue} // 1 is the default value to be selected when the component is rendered
      row
      name="radio-buttons-group"
      onChange={onChange}>
      {choices.map((choice, index) => (
        <FormControlLabel
          key={index}
          value={choice.value}
          control={<Radio />}
          label={choice.label}
        />
      ))}
    </RadioGroup>
  );
};
export default BasicRadioGroup;
